import React, { useState } from "react";
import { artifactUrl } from "../../lib/api";
import { ExternalLink, AlertTriangle } from "lucide-react";

const Artifact = ({ blockId, label }) => {
  const [failed, setFailed] = useState(false);
  const url = artifactUrl(blockId);

  return (
    <div className="pillet-card my-6" data-testid="html-artifact">
      <div className="flex items-center justify-between px-4 py-2 border-b border-pillet-forest">
        <span className="font-heading text-xs uppercase tracking-widest text-pillet-sage">
          Illustration interactive
        </span>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 text-xs text-pillet-muted hover:text-pillet-sage transition-colors"
          data-testid="artifact-open"
        >
          <ExternalLink size={14} /> Ouvrir
        </a>
      </div>
      {failed ? (
        <div className="p-8 flex flex-col items-center gap-3 text-center">
          <AlertTriangle className="text-pillet-sage" size={28} />
          <p className="text-pillet-muted text-sm">
            Cette illustration ne peut pas s'afficher ici.
          </p>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="pillet-dashed px-4 py-2 text-pillet-sage font-heading uppercase text-xs tracking-wider hover:bg-pillet-sage hover:text-black transition-colors"
          >
            Ouvrir dans un nouvel onglet
          </a>
        </div>
      ) : (
        <iframe
          src={url}
          title={label || "Illustration interactive"}
          className="w-full bg-white"
          style={{ height: "640px", border: "none" }}
          sandbox="allow-scripts allow-popups allow-forms"
          onError={() => setFailed(true)}
          data-testid="artifact-iframe"
        />
      )}
    </div>
  );
};

export default Artifact;
